import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1EB18C03-3143-42C6-ACA9-D62086DA371D
 * name skip-forward-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-forward-outline.svg
 * tags
 */
export const SkipForwardOutlineIcon = createSvgIcon(<><path d="M6,9.83L8.17,12L6,14.17V9.83M4,5V19L11,12M20,5H18V19H20M13,9.83L15.17,12L13,14.17V9.83M11,5V19L18,12" /></>, 'SkipForwardOutlineIcon');
export default SkipForwardOutlineIcon